export default "__VITE_ASSET__DdDmwsKM__"